import axios from 'axios';

import env from '../config/env';
import { getUserToken } from '../helpers/session';

const api = axios.create({
  baseURL: env.API_URL,
  timeout: 40000
});

api.interceptors.request.use(async config => {
  const { token } = await getUserToken();

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
